import React from "react";
import { useEffect, useState } from 'react';
import ReactSpeedometer from "react-d3-speedometer"
import { Card, CardHeader } from "reactstrap";
import {CardBody} from "reactstrap";
import './Miniwidget.css'
import { apiEndpoint } from "helpers/url_helper";

var speedoMeterProps=[];
const Speedometer= props =>  {
    const [todaysMaxSpeed, settodaysMaxSpeed] = useState([]);
    const [monthlyMaxSpeed, setmonthlyMaxSpeed] = useState([]);
    const [todaysAvgSpeed, settodaysAvgSpeed] = useState([]);
    const [bounce, setbounce] = useState(false);

    useEffect(() => {
setbounce(true)
        var intCampusID=props.CampusID;
        // UserValidated
        const getData = async () => {
          const url = apiEndpoint+'/GetTodaysMaxSpeed';
        try {
        const response = await fetch(url, 
          { method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            "intCampusID": intCampusID,
            "strToken": sessionStorage.getItem("Clear_AuthUser")
          })
        });

         if(response.body!=null){
        const data = await response.json();
        //console.log(data)
        settodaysMaxSpeed(data.MaxSpeed);
         }
      
         // UserValidated
      const urlMonth = apiEndpoint+'/GetMonthlyMaxSpeed';
     
      const responseMonthly =await fetch(urlMonth, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "intCampusID": intCampusID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      });
       if(responseMonthly.body!=null){
      const dataMonthly = await responseMonthly.json();
      //console.log(dataMonthly)
      setmonthlyMaxSpeed(dataMonthly.MaxSpeed);
       }

       // UserValidated
       const urlAvg = apiEndpoint+'/GetTodaysAvgSpeed';
     
      const responseAvg =await fetch(urlAvg,  {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          "intCampusID": intCampusID,
          "strToken": sessionStorage.getItem("Clear_AuthUser")
        })
      })  ;
       if(responseAvg.body!=null){
      const dataAvg = await responseAvg.json();
      //console.log(dataAvg)
      settodaysAvgSpeed(dataAvg.AvgSpeed);
       }
    } catch (error) {
        console.log(error);
    }
      };
        getData();
      }, [props.CampusID]);
    

 
if(props.type=="dailyMax"){
    speedoMeterProps=[
        {  value: todaysMaxSpeed, 
            maxValue:100,
            width:138,
            height:92,
            divHeight:"100%",
            divWidth:"100%",
            title:"Today's Highest Speed" }]
}
else if(props.type=="monthlyMax"){
    speedoMeterProps=[
        {  value: monthlyMaxSpeed, 
            maxValue:100,
            width:138,
            height:92,
            divHeight:"100%",
            divWidth:"100%",
            title:"Monthly Highest Speed" }]
}
else if(props.type=="dailyAvg"){
    speedoMeterProps=[
        {  value: todaysAvgSpeed, 
            maxValue:100,
            width:256,
            height:175,
            divHeight:"100%",
            divWidth:"100%",
            title:"Today's Average Speed" }]
        }
  return (
    <React.Fragment>    
          {speedoMeterProps.map((param,key) => (
                <div  className={bounce ? 'bounce' : ''}  onAnimationEnd={() => setbounce(false)}>

                  
    <Card className="mini-stat " style={{display : 'flex',width:param.divWidth ,justifyContent:'center', alignItems:'center'}}>
  

    <CardBody  style={{ height:param.divHeight,minHeight:param.divHeight}}>     

    <h5 style={{width:param.divWidth}}>{param.title} </h5>
  <ReactSpeedometer forceRender={true}  value={param.value} maxValue={param.maxValue} needleTransition="easeQuadOut" 
  needleTransitionDuration={1000}width={param.width} height={param.height} startColor="rgb(106, 215, 45)" endColor="red"></ReactSpeedometer>
   </CardBody>  
  </Card>
  </div>
   ))}
   </React.Fragment>
  )
  }
export default Speedometer
